import { useEffect } from 'react';

import { useStore } from '../zustand/stores';

export const useResponsive = () => {
  const isMobile = useStore((s) => s.deviceSlice.isMobile);
  const isTablet = useStore((s) => s.deviceSlice.isTablet);
  const setDeviceFromWidth = useStore((s) => s.deviceSlice.setDeviceFromWidth);

  useEffect(() => {
    const handleResize = () => setDeviceFromWidth(window.innerWidth);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setDeviceFromWidth]);

  return { isMobile, isTablet };
};
